import { render, staticRenderFns } from "./RegistrationMainPage.vue?vue&type=template&id=1bc9ed0f&scoped=true&"
import script from "./RegistrationMainPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9ed0f",
  null
  
)

export default component.exports